function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { Plus } from './../../../common/icons';
export function AvatarTrigger(props) {
  var disabled = props.disabled;
  var _props$size = props.size,
      size = _props$size === void 0 ? {
    width: '120px',
    height: '120px'
  } : _props$size,
      children = props.children;
  var cls = usePrefixCls('upload-avatar-trigger', {
    disabled: disabled
  });
  var contentCls = usePrefixCls('upload-avatar-trigger-content');
  var locale = useLocale('upload.click');
  return React.createElement("div", {
    className: cls,
    style: _objectSpread({}, size)
  }, children ? children : React.createElement("div", {
    className: contentCls
  }, React.createElement("div", null, React.createElement(Plus, null)), React.createElement("div", null, locale)));
}